import { Region } from '../types/orderTypes';
import { queryStringFromObject } from 'utils/urlUtil';
import Fetch from '../utils/fetch';
import { settings } from '../settings';
import dayjs, { Dayjs } from 'dayjs';
import { CourierInvoice } from '../types/reportTypes';

//  'https://api.porterbuddy-test.com/reports/courier/deliveries?start=2020-01-01&end=2020-01-10'

export async function fetchAllOrdersDeliveredAtForReportAsync(
  startDate: Dayjs,
  endDate: Dayjs,
  region: Region = undefined
): Promise<CourierInvoice[]> {
  const queryParams = {
    start: dayjs(startDate).format('YYYY-MM-DD'),
    end: dayjs(endDate).format('YYYY-MM-DD'),
    region,
  };
  const queryString = queryStringFromObject(queryParams);

  const response = await Fetch.get({
    url: `${settings.newApiUrl}/reports/courier/deliveries${queryString}`,
  });

  const courierInvoiceList: CourierInvoice[] = await response.json();

  return courierInvoiceList;
}
